import {get, post, del, put} from '@/api';
import * as VITAL from '../constants/vital';

export default {
  /**
   * Add new vital
   *
   * @param commit
   * @param payload
   */
  [VITAL.ACTION_ADD]: ({commit}, payload) => {
    return post('/vital', payload);
  },

  [VITAL.ACTION_DELETE]: ({commit}, payload) => {
    return del(`/vital/${payload.id}`);
  },

  [VITAL.ACTION_UPDATE]: ({commit}, payload) => {
    return put(`/vital/${payload.id}`, payload);
  }
}



// WEBPACK FOOTER //
// ./src/store/vital/actions.js